/* unplugin-vue-components disabled */import script from "./contactCards.vue?vue&type=script&lang=js"
export * from "./contactCards.vue?vue&type=script&lang=js"

import "./contactCards.vue?vue&type=style&index=0&id=55e5e219&lang=scss"

const __exports__ = script;

export default __exports__